import { render, staticRenderFns } from "./SalidaInventarioTableComponent.vue?vue&type=template&id=6380f32b&"
import script from "./SalidaInventarioTableComponent.vue?vue&type=script&lang=js&"
export * from "./SalidaInventarioTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports